import JSKUList from './JSKUList'

/* istanbul ignore next */
JSKUList.install = function (Vue) {
  Vue.component(JSKUList.name, JSKUList)
}

export default JSKUList
